import { useState, useEffect } from 'react';
import type { PromotionConfig } from '@/modelsLocal/promotion-modal';
import type { FeatureConfig } from '@/models/feature-config';
import { isPromotionActive, matchesPromotionAudience } from '@/consts/promotion';

const STORAGE_KEY = `bolzai_${import.meta.env.VITE_NAMESPACE}_promotionModalLastShown`;

function wasShownToday(): boolean {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === null) return false;
  return new Date(stored).toDateString() === new Date().toDateString();
}

export function usePromotionModal(config: PromotionConfig, featureConfig: FeatureConfig | null) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!matchesPromotionAudience(config.audience, featureConfig)) return;
    if (!isPromotionActive(config)) return;
    if (wasShownToday()) return;
    setIsOpen(true);
  }, [config, featureConfig]);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setIsOpen(false);
  };

  return { isOpen, handleClose };
}
